import { BaseIconProps } from "../../types/styles";

const LockIcon = ({
    id,
    className,
    size = 24,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--primary-700)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-lock"}
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
    );
};

export default LockIcon;
